import { useEffect, useState } from "react";

/**
 * Returns true once the window has scrolled past `threshold` pixels.
 * Used by the sticky header to flip from transparent to solid+blurred.
 */
export function useScrolled(threshold = 24) {
  const [scrolled, setScrolled] = useState(
    typeof window !== "undefined" && window.scrollY > threshold
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return scrolled;
}
